import { landingApiRequest } from '@/lib/landing-api'
import type { MascotCareBenefit } from './mascot-care-options'

export type MascotEnergyPurchase = {
  id: string
  campaign_id: number
  amount_cents: number
  institution_name: string
  status: 'creating' | 'creation_uncertain' | 'pending' | 'expired' | 'paid'
  pix_key: string | null
  expires_at: string | null
  fulfilled_at: string | null
  benefit?: MascotCareBenefit
}

export type MascotEnergyCatalog = {
  amount_cents: number
  institution_name: string
  sales_open: boolean
  purchase: MascotEnergyPurchase | null
}

export function fetchMascotEnergyCatalog(campaignId: number, signal?: AbortSignal) {
  return landingApiRequest<MascotEnergyCatalog>(
    `/api/donor/campaigns/${campaignId}/mascot-energy`,
    { signal, cache: 'no-store' }
  )
}

export function createMascotEnergyPurchase(
  campaignId: number,
  requestId: string,
  benefit?: MascotCareBenefit
) {
  return landingApiRequest<MascotEnergyPurchase>(
    `/api/donor/campaigns/${campaignId}/mascot-energy`,
    {
      method: 'POST',
      body: JSON.stringify({ request_id: requestId, ...(benefit ? { benefit } : {}) }),
    }
  )
}

export function fetchMascotEnergyPurchase(id: string, signal?: AbortSignal) {
  return landingApiRequest<MascotEnergyPurchase>(
    `/api/donor/mascot-energy/${encodeURIComponent(id)}`,
    { signal, cache: 'no-store' }
  )
}
